export default __webpack_public_path__ + "static/media/problema-10.a333a6b9.webp";